<template>
  <div v-if="purchases && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="purchases"
    />
  </div>
</template>
<script>
import Purchases from "@/api/purchases";

import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";

export default {
  components: {
    MutiplePiecesPrint,
  },
  data: () => ({
    formater: null,
    purchases: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("adminPurchase").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          this.formater = formater;
          //获取单据详情
          Purchases.purchasesPrint(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.purchases = response.data.purchases.map((purchase) => {
                  purchase.purchase_details.map((d) => {
                    d.sum = Number(d.price) * Number(d.quantity);
                    if (d.negotiate_price_flg == 1) {
                      // 显示后议价
                      // 单价
                      d.price = this.$t(
                        "PurchasesDetail.purchaseFields.negotiatePrices"
                      );
                      // 采购金额
                      d.total = this.$t(
                        "PurchasesDetail.purchaseFields.negotiatePrices"
                      );
                    }
                    return d;
                  });
                  return purchase;
                });
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>